
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/all-promotions",
      function () {
        return require("private-next-pages/all-promotions.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/all-promotions"])
      });
    }
  